/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

// Ручка ресайза: зона захвата 8px у правой границы ячейки, визуально — линия 1px.
export const StyledColumnResizer = styled(Box)(({theme}) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  height: '100%',
  width: '8px',
  display: 'flex',
  justifyContent: 'flex-end',
  cursor: 'col-resize',
  userSelect: 'none',
  touchAction: 'none',
  // Выше sticky-ячейки шапки (z-index 2), иначе ручку перекрывает соседняя колонка.
  zIndex: 3,

  '&::after': {
    content: '""',
    width: '1px',
    height: '100%',
    backgroundColor: theme.palette.figma_gray_light_1?.main,
    opacity: 0,
  },

  '&:hover::after, &[data-dragging="true"]::after': {
    opacity: 1,
  },
}));
